/**
 * Composable untuk handle search dengan debounce
 * @param {Object} vm - Vue component instance
 * @param {Function} onSearch - Callback yang dipanggil saat search dilakukan
 * @param {number} delay - Delay dalam milliseconds (default: 500)
 * @returns {Object} Object berisi search state dan methods
 */
const useDebouncedSearch = (vm, onSearch, delay = 500) => {
  const internalState = vm.$data
  // Initialize state in component
  if (!internalState.searchDebounceId) {
    internalState.searchDebounceId = null
  }
  if (!internalState.lastSearchedKeyword) {
    internalState.lastSearchedKeyword = ''
  }

  const performSearch = keyword => {
    const normalizedKeyword = (keyword || '').trim()

    // Skip if keyword unchanged
    if (normalizedKeyword === internalState.lastSearchedKeyword) {
      return
    }

    internalState.lastSearchedKeyword = normalizedKeyword

    // Call the search callback
    if (onSearch) {
      onSearch(normalizedKeyword)
    }
  }

  const handleSearchInput = keyword => {
    if (internalState.searchDebounceId) {
      clearTimeout(internalState.searchDebounceId)
    }

    internalState.searchDebounceId = setTimeout(() => {
      performSearch(keyword)
    }, delay)
  }

  const cleanup = () => {
    if (internalState.searchDebounceId) {
      clearTimeout(internalState.searchDebounceId)
      internalState.searchDebounceId = null
    }
    internalState.lastSearchedKeyword = ''
  }

  const reset = () => {
    cleanup()
  }

  return {
    handleSearchInput,
    performSearch,
    cleanup,
    reset,
  }
}

export default useDebouncedSearch
